<!-- 购物车 -->
<template>
  <n-badge
    v-if="datas.settings?.header?.settings?.shop_car"
    color="rgba(198, 156, 109, 1)"
    :max="9"
    :value="count"
    @click="showcar"
  >
    <div class="flex items-center justify-center">
      <BlocksHeadersComponentsCartIcon />
    </div>
  </n-badge>
</template>

<script lang="ts" setup>
defineProps<{
  datas: any
  count: any
}>()

const { showCart } = storeToRefs(useShopCart())

/**  打开购物车 */
const showcar = () => {
  showCart.value = true
}
</script>

<style lang="scss" scoped></style>
